import { renderRoutes } from 'react-router-config'

function Blank(props) {
  const { route } = props
  return renderRoutes(route.routes)
}

export default Blank
